import ScrollReveal from 'scrollreveal';

const sr = ScrollReveal({
  reset: true
});

export default sr;
